import React from 'react';
import { Mail, Phone, MapPin, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer-dark">
      <div className="footer-content">
        <div className="footer-grid">
          <div className="footer-section">
            <div className="footer-brand">
              <img 
                src="https://customer-assets.emergentagent.com/job_sg-ind-experts/artifacts/puzsc844_bizzentrum%20b.png" 
                alt="Bizenntrum" 
                style={{ 
                  height: '40px', 
                  width: 'auto',
                  objectFit: 'contain',
                  marginBottom: '12px'
                }}
              />
              <h3 className="footer-brand-name">Bizenntrum</h3>
            </div>
            <p className="footer-text">
              <strong style={{ color: 'var(--text-secondary, #d1d5db)', display: 'block', marginBottom: '4px' }}>Strategic Growth, Cross-Border Expansion &amp; M&amp;A Advisory</strong>
              Helping founder & owner-led businesses grow across India, Singapore &amp; ASEAN.
            </p>
            <p className="footer-text" style={{ marginTop: '10px', fontSize: '13px', color: 'var(--text-muted, #9ca3af)' }} data-testid="footer-pte-ltd">
              Bizenntrum Pte. Ltd. — a Singapore-registered advisory platform serving clients across India, Singapore, and ASEAN.
            </p>
          </div>

          <div className="footer-section">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li><a href="#services">Services</a></li>
              <li><a href="#credibility">About Us</a></li>
              <li><a href="#team">Our Team</a></li>
              <li><a href="#resources">Resources</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-heading" data-testid="footer-advisory-services-heading">Advisory Services</h3>
            <ul className="footer-links" data-testid="footer-advisory-services-list">
              <li><a href="#services">M&amp;A &amp; Strategic Growth Advisory</a></li>
              <li><a href="#framework">10→100 CFO System</a></li>
              <li><a href="#signature-offer">India–Singapore Growth &amp; Market Entry Program</a></li>
              <li><a href="#singapore-india">India Market Entry (for Singapore SMEs)</a></li>
              <li><a href="#services">Singapore / ASEAN Expansion (for India SMEs)</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-heading">Contact</h3>
            <div className="footer-contact">
              <div className="contact-item">
                <MapPin size={18} className="footer-loc-icon footer-loc-icon--in" />
                <div>
                  <span>India: Hyderabad. Chennai. Mumbai</span>
                  <span className="contact-sub">WhatsApp: +91 90003 09533</span>
                </div>
              </div>
              <div className="contact-item">
                <MapPin size={18} className="footer-loc-icon footer-loc-icon--sg" />
                <div>
                  <span>Singapore</span>
                  <span className="contact-sub">WhatsApp: +65 8017 9673</span>
                </div>
              </div>
              <div className="contact-item">
                <Mail size={18} />
                <span>opsdesk@bizenntrum.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Bizenntrum Pte. Ltd. All rights reserved.</p>
          <div className="footer-legal-links">
            <a href="/privacy-policy">Privacy Policy</a>
            <span className="separator">•</span>
            <a href="/terms-conditions">Terms & Conditions</a>
          </div>
          <div className="footer-social">
            <a href="https://www.linkedin.com/company/bizenntrum" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <Linkedin size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
